<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_917')}}</div>
    <div slot="body">
      <a-descriptions :title="$t('scope.text_918')" :column="2">
        <a-descriptions-item :label="$t('scope.text_322')">
          {{ params.data[0].name }}
          <copy
            class="ml-1"
            :message="params.data[0].name" />
        </a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_494')">
          {{params.data[0].mobile}}
          <copy
            class="ml-1"
            :message="params.data[0].mobile" />
        </a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_318')">
          {{enterpriseInfo.name}}
          <copy
            class="ml-1"
            :message="enterpriseInfo.name" />
        </a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_588')">
          {{enterpriseInfo.license_number}}
          <copy
            class="ml-1"
            :message="enterpriseInfo.license_number" />
        </a-descriptions-item>
        <a-descriptions-item :label="this.unitTypes[enterpriseInfo.license_type]">
            <a-tooltip>
              <template slot="title">
                {{unitTypes[enterpriseInfo.license_type]}}
              </template>
              <a-icon type="file-image" @click="viewImage(enterpriseInfo.license_type === 'business' ? 'credentials' : 'letter-of-auth')" class="imageIcon" />
            </a-tooltip>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_591')">{{$t('scope.text_601')}}</a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_592')">{{addressDesc}}</a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_594')">{{enterpriseInfo.postcode}}</a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_614')">{{enterpriseInfo.last_name}}</a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_615')">{{enterpriseInfo.first_name}}</a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_617')">
          <a-tooltip>
            <template slot="title">{{$t('scope.text_919')}}</template>
            <a-icon type="file-image" @click="viewImage('indentiycard-a')" class="mr-2 imageIcon" />
          </a-tooltip>
          <a-tooltip>
            <template slot="title">{{$t('scope.text_920')}}</template>
            <a-icon type="file-image" @click="viewImage('indentiycard-b')" class="imageIcon" />
          </a-tooltip>
        </a-descriptions-item>
      </a-descriptions>
      <a-divider />
<!--      <cloud-account-init-setting ref="setting" :customerId="params.data[0].id" />-->
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{$t('scope.text_883')}}</a-button>
      <a-button @click="handleRefuse">{{$t('scope.text_884')}}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import paperworkFile from '../components/paperworkFile'
// import CloudAccountInitSetting from '../components/CloudAccountInitSetting'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'TenantAuthenticateDialog',
  // components: {
  //   CloudAccountInitSetting,
  // },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      enterpriseInfo: {},
      cityOps: [],
      addressDesc: '',
      unitTypes: {
        business: this.$t('scope.text_605'),
        institution: this.$t('scope.text_609'),
      },
    }
  },
  computed: {
    ...mapGetters(['scope']),
    ...mapState('app', {
      customer: state => state.customer,
    }),
  },
  created () {
    this.manager = new this.$Manager('customers')
    this.fetchEnterPriseInfo()
    this.$bus.$on('tenant:refuseSuccess', () => {
      this.params.refresh()
      this.cancelDialog()
    })
  },
  destroyed () {
    this.manager = null
  },
  methods: {
    fetchEnterPriseInfo () {
      this.manager.getSpecific({ id: this.params.data[0].id, spec: 'enterprise-info' }).then(res => {
        this.enterpriseInfo = res.data
        this.addressDesc = ''
        this.enterpriseInfo.addressCode = []
        this.fetchCities()
      })
    },
    deepTraversal (val, list) {
      let desc = ''
      if (val) {
        const valPrefix = val.slice(0, 3)
        list.map(item => {
          const itemPrefix = item.value.slice(0, 3)
          if (valPrefix === itemPrefix && item.children && item.children.length) {
            item.children.map(chilItem => {
              if (val === chilItem.value) {
                this.addressDesc = item.label + chilItem.label
                desc = item.label + chilItem.label
                this.enterpriseInfo.addressCode.push(item.value)
                this.enterpriseInfo.addressCode.push(chilItem.value)
              }
            })
          }
        })
      }
      return desc
    },
    async fetchCities () {
      const { data } = await this.$http.get('/v2/cities?nation_code=CN')
      this.cityOps = data.data
      this.deepTraversal(this.enterpriseInfo.reg_address, this.cityOps)
    },
    async viewImage (type) {
      const id = this.params.data[0].id
      this.$info({
        title: this.$t('scope.text_921'),
        okText: this.$t('scope.text_922'),
        width: 600,
        content (h) {
          return [
            <paperworkFile type={type} id={id} />,
          ]
        },
        onOk () {},
      })
    },
    doAuthenticate (data) {
      return new this.$Manager('customers').performAction({
        action: 'enterprise-review',
        id: this.params.data[0].id,
        data: data,
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const data = await this.$refs.setting.getValues()
        await this.doAuthenticate({ approved: true, ...data })
        this.loading = false
        this.params.refresh()
        this.cancelDialog()
      } catch (error) {
        this.loading = false
      }
    },
    async handleRefuse () {
      this.createDialog('TenantRefuseDialog', {
        data: this.params.data,
        refresh: this.params.refresh,
      })
    },
  },
}
</script>

<style lang="less" scoped>
  ::v-deep {
    .imageIcon{
      font-size: 16px;
      cursor: pointer;
      color: #1890ff;
    }
  }
</style>
